export const filterTableActions = {
	STATE_CHANGE: "state-change",
	RESET_FILTER: "reset-filter",
	NEXT_PAGE: "next-page",
	PREVIOUS_PAGE: "previous-page",
	SET_PAGE: "set-page",
};

export const filterTableReducer = (state, action) => {
	switch (action.type) {
		case filterTableActions.STATE_CHANGE:
			const { filterName, filterValue } = action.payload;

			return {
				...state,
				filters: { ...state.filters, [filterName]: filterValue === "All" ? undefined : filterValue }, //checking if filter value is all, if yes then remove the filter
			};

		case filterTableActions.RESET_FILTER:
			return { initialFilters: state.initialFilters, filters: state.initialFilters };

		case filterTableActions.NEXT_PAGE:
			return { ...state, filters: { ...state.filters, page: state.filters.page + 1 } };

		case filterTableActions.PREVIOUS_PAGE:
			return { ...state, filters: { ...state.filters, page: state.filters.page - 1 } };

		case filterTableActions.SET_PAGE:
			return { ...state, filters: { ...state.filters, page: action.payload } };

		default:
			throw new Error("Invalid value");
	}
};
